import * as React from 'react';

const styles = require('./tab_page.css');

export type StandardTabId =
  | 'yardPark'
  | 'decoration'
  | 'facades'
  | 'entrances'
  | 'elevators'
  | 'environment'
  | 'schools'
  | 'lobby'
  | 'steps'
  | 'howItsDone'
  | 'playability'
  | 'sockets';

interface IProps {
  id: StandardTabId;
  title: string;
  description: string | JSX.Element;
  icons?: { description?: string; icon: React.ReactNode }[];
}

export class TabPage extends React.PureComponent<IProps, object> {
  public render() {
    const { title, description, icons } = this.props;

    return (
      <div className={styles['tab-page']}>
        <div className={styles['title']}>{title}</div>
        <div className={styles['description']}>{description}</div>

        {icons && (
          <div className={styles['icons']}>
            {icons.map((icon, index) => (
              <span key={index} className={styles['icon-container']}>
                <div className={styles['icon-wrapper']}>
                  <div className={styles['icon']}>{icon.icon}</div>
                </div>
                <div>{icon.description}</div>
              </span>
            ))}
          </div>
        )}
      </div>
    );
  }
}
